module.exports = __webpack_public_path__ + "static/media/hero-short.cd9fb129.jpg";